import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

const HEX_COMPLETO = /^#[0-9A-Fa-f]{6}$/;

// Seletor de cor + campo hex. A landing aplica a cor em degradê até transparente.
// O <input type="color"> nativo não aceita vazio, então o campo texto permite
// limpar (vazio = landing usa a cor padrão Setpar).
const CorField = ({
  name,
  label,
  ajuda,
  value,
  error,
  touched,
  setFieldValue,
  setFieldTouched,
}) => (
  <Form.Group>
    <Form.Label>{label}</Form.Label>
    <InputGroup>
      <InputGroup.Prepend>
        <Form.Control
          type="color"
          aria-label={`${label} (seletor)`}
          value={HEX_COMPLETO.test(value) ? value : '#000000'}
          onChange={(e) => {
            setFieldValue(name, e.target.value.toUpperCase());
            setFieldTouched(name, true, false);
          }}
          style={{ width: 56, padding: 4, height: 'auto' }}
        />
      </InputGroup.Prepend>
      <Form.Control
        type="text"
        name={name}
        value={value}
        onChange={(e) => setFieldValue(name, e.target.value)}
        onBlur={() => setFieldTouched(name, true)}
        isInvalid={touched && !!error}
        placeholder="#RRGGBB"
        maxLength={7}
      />
      <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
    </InputGroup>
    {HEX_COMPLETO.test(value) && (
      <div
        title="Prévia do degradê"
        style={{
          height: 12,
          marginTop: 6,
          borderRadius: 4,
          border: '1px solid #dee2e6',
          background: `linear-gradient(90deg, ${value}, transparent)`,
        }}
      />
    )}
    {ajuda && <Form.Text className="text-muted">{ajuda}</Form.Text>}
  </Form.Group>
);

export default CorField;
